import { apiV2 } from '../axios';
import {
  HurdlrAccountantPermission,
  HurdlrAccountingMethod,
  HurdlrToken,
} from './types';

export const getHurdlrAccountantToken = async (
  organizationID?: string,
): Promise<HurdlrToken> => {
  const { data } = await apiV2.get<HurdlrToken>(
    `hurdlr/${organizationID}/accountant-token`,
  );
  return data;
};

export const createHurdlrAccountant = async (
  userID?: string,
  organizationID?: string,
  permission?: HurdlrAccountantPermission,
): Promise<string | null> => {
  const { data } = await apiV2.post<
    HurdlrAccountantPermission,
    { data: string }
  >(`hurdlr/${organizationID}/accountant-registration/${userID}`, permission);
  return data;
};

export const deleteHurdlrAccountant = async (
  userID?: string,
  organizationID?: string,
): Promise<void> => {
  await apiV2.delete(
    `hurdlr/${organizationID}/accountant-registration/${userID}`,
  );
};

export const assignUserToSelf = async (
  businessId?: string,
  accountingMethod?: HurdlrAccountingMethod,
): Promise<void> =>
  apiV2.post(`hurdlr/accountant/${businessId}/assignment`, {
    accountingMethod,
  });

export const removeHurdlrAccountantAccessToCustomer = async (
  businessId: string,
): Promise<void> => {
  await apiV2.delete(`hurdlr/accountant/${businessId}/assignment`);
};
